import type { i18n } from "i18next";
import { createFormat, type DateStyle } from "./format.ts";
import { DEFAULT_LOCALE, LOCALES, type Locale } from "./locales.ts";

/**
 * Lets copy say `{{n, percent}}`, `{{amount, currency(EUR)}}`, `{{when, relative}}` and `{{day, date(long)}}` in
 * the reader's conventions. Shared by the server's instance (`i18n.ts`) and the web app's (`web.ts`).
 */
export function registerFormatters(instance: i18n, options: { timeZone?: string } = {}): void {
  const formatter = instance.services.formatter;
  if (formatter) {
    const fmt = (lng: string | undefined) =>
      createFormat(
        (LOCALES as readonly string[]).includes(lng ?? "") ? (lng as Locale) : DEFAULT_LOCALE,
        options,
      );
    formatter.add("percent", (value: number, lng) => fmt(lng).percent(value));
    formatter.add("percentChange", (value: number, lng) => fmt(lng).percentChange(value));
    formatter.add("currency", (value: number, lng, opts: { currency?: string }) =>
      fmt(lng).currency(value, opts.currency ?? "EUR"),
    );
    formatter.add("date", (value: Date | string | number, lng, opts: { style?: DateStyle }) =>
      fmt(lng).date(value, opts.style ?? "medium"),
    );
    formatter.add("relative", (value: Date | string | number, lng) => fmt(lng).relative(value));
  }
}
